var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPremiumPattern(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1430.53 1436.51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke-miterlimit:10;stroke-width:3px;stroke:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-2);}.cls-3{fill:url(#linear-gradient-3);}.cls-4{fill:url(#linear-gradient-4);}.cls-5{fill:url(#linear-gradient-5);}.cls-6{fill:url(#linear-gradient-6);}.cls-7{fill:url(#linear-gradient-7);}.cls-8{fill:url(#linear-gradient-8);}.cls-9{fill:url(#linear-gradient-9);}.cls-10{fill:url(#linear-gradient-10);}.cls-11{fill:url(#linear-gradient-11);}.cls-12{fill:url(#linear-gradient-12);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 390.88,
    y1: 384.83,
    x2: 818.33,
    y2: 138.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1420a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#0b1256"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#4657fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#1420a9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 708.92,
    y1: 1387.65,
    x2: 1133.52,
    y2: 1142.51,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -9.21,
    y1: 670.63,
    x2: 415.38,
    y2: 425.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 484.84,
    y1: 999.44,
    x2: 1064.73,
    y2: 664.63,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 359.02,
    y1: 1403.08,
    x2: 628.19,
    y2: 1247.67,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 873.25,
    y1: 596.12,
    x2: 1142.43,
    y2: 440.72,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 291.32,
    y1: 1262.56,
    x2: 156.68,
    y2: 1029.36,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 1204.17,
    y1: 1298.57,
    x2: 1338.81,
    y2: 1531.77,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 1463.01,
    y1: 922.85,
    x2: 1106.59,
    y2: 922.85,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 1109.59,
    y1: 66.35,
    x2: 1463.01,
    y2: 66.35,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 1109.59,
    y1: 201.74,
    x2: 1463.01,
    y2: 201.74,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 1109.59,
    y1: 337.12,
    x2: 1463.01,
    y2: 337.12,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M391.86,383.91c0-198.19,160.67-358.86,358.86-358.86v359H391.59",
    transform: "translate(-32.49 -23.55)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1106.57,1104.06c-1.61,193.91-159,351.36-352.85,353V1295.5c104.82-1.59,189.78-86.59,191.37-191.44h161.48m3-3H942.12c0,105.57-85.86,191.46-191.4,191.46v167.53c197.88,0,358.87-161,358.87-359Z",
    transform: "translate(-32.49 -23.55)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M388.44,387.05C386.82,581,229.42,738.4,35.59,740V578.48C140.4,576.89,225.37,491.9,227,387.05H388.44m3-3H224c0,105.57-85.86,191.46-191.39,191.46V743c197.88,0,358.86-161,358.86-359Z",
    transform: "translate(-32.49 -23.55)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1106.57,745.32c-1.62,194.91-160.63,353-355.85,353s-354.22-158.08-355.85-353H556.35C558,851.17,644.53,936.78,750.72,936.78s192.77-85.61,194.37-191.46h161.48m3-3H942.12c0,105.57-85.86,191.46-191.4,191.46S559.33,847.89,559.33,742.32H391.86c0,197.95,161,359,358.86,359s358.87-161,358.87-359Z",
    transform: "translate(-32.49 -23.55)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M394.86,1108.31,743.52,1457H394.86V1108.31m-3-7.25V1460h358.9l-358.9-358.91Z",
    transform: "translate(-32.49 -23.55)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1106.59,386.83V735.49L757.93,386.83h348.66m3-3H750.68l358.91,358.9V383.83Z",
    transform: "translate(-32.49 -23.55)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M388.46,1104.06A176.5,176.5,0,0,1,87.18,1225.87a175.28,175.28,0,0,1-51.67-121.81h353m3-3h-359a179.5,179.5,0,0,0,359,0Z",
    transform: "translate(-32.49 -23.55)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1283.51,1283.56A176.51,176.51,0,0,1,1460,1457.06H1107a176.51,176.51,0,0,1,176.47-173.5m0-3a179.51,179.51,0,0,0-179.5,179.5h359a179.5,179.5,0,0,0-179.5-179.5Z",
    transform: "translate(-32.49 -23.55)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1460,747.65v350.41H1109.6A353.11,353.11,0,0,1,1460,747.65m3-3c-196.85,0-356.42,159.57-356.42,356.42H1463V744.64Z",
    transform: "translate(-32.49 -23.55)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1460,28.05v76.6H1112.59V28.05H1460m3-3H1109.59v82.6H1463V25.05Z",
    transform: "translate(-32.49 -23.55)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1460,163.43V240H1112.59V163.43H1460m3-3H1109.59V243H1463V160.43Z",
    transform: "translate(-32.49 -23.55)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1460,298.82v76.6H1112.59v-76.6H1460m3-3H1109.59v82.6H1463v-82.6Z",
    transform: "translate(-32.49 -23.55)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremiumPattern);
export default __webpack_public_path__ + "static/media/premium_pattern.a75dc01a5f0d0567bb44a0b8042a2ab3.svg";
export { ForwardRef as ReactComponent };